import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [totalSeconds, setTotalSeconds] = useState(13 * 60 + 11);
  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formatted = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-red-700 text-white h-12 md:h-14 flex items-center justify-center px-4 shadow-lg" data-id="element-15">
      <p className="font-heading font-bold text-sm md:text-lg tracking-wide" data-id="element-16">
        ⏳ OFERTA EXPIRA EN:{' '}
        <span className="countdown-pulse text-yellow-300 text-base md:text-xl font-bold mx-1 inline-block min-w-[60px]" data-id="element-17">
          {formatted}
        </span>{' '}
        | 🔥 CUPOS LIMITADOS
      </p>
    </div>;
}